<dx-popup title="Jobs" [width]="1000" [height]="800" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dx-data-grid
        #customerJobsGrid
        keyExpr="id"
        class="d-flex flex-fill flex-column"
        [dataSource]="jobs"
        [height]="'400px'"
        [showBorders]="true"
        style="min-height: 650px; min-width: 750px"
        (onToolbarPreparing)="onToolbarPreparing($event)"
    >
        <dxi-data-grid-column dataField="id" caption="Job #" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="margin" width="100" [format]="{ type: 'percent', precision: 2 }"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="85"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action.name" caption="Action" width="85"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driver.displayName" caption="Driver" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="weight" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpSite.name" caption="Dump Location" width="135"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'">
            <span class="me-3">
                <strong>{{ customerJobsGrid.instance.totalCount() + ' items' }}</strong>
            </span>
        </div>
        <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
    </dx-data-grid>
</dx-popup>
